(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"));
	else if(typeof define === 'function' && define.amd)
		define("PureLifecycle", ["react"], factory);
	else if(typeof exports === 'object')
		exports["PureLifecycle"] = factory(require("react"));
	else
		root["PureLifecycle"] = factory(root["React"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE_react__) {
return 